import styled from 'styled-components';

export const ErrorPage = styled.div`
  min-height: 100vh;
	width: 100%;
	padding-top: var(--mg-top-page-lg);
	box-sizing: border-box;

	.errpr-banner {
		opacity: 0;
		animation: fadeIn 0.4s ease 0.2s forwards;
	}
	
	@keyframes fadeIn {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

	button {
		justify-content: flex-start;
		font-size: var(--fs-lg);
	}
`;
